export default "__VITE_ASSET__9f94da6d__"